// src/utils/interpretacaoICV.js
// Devolutivas técnicas em PT-BR, sem treino.

const interpretacaoICV = {
  DGV: {
    muito_baixo:
      'Não mostra uma disposição geral para a venda; dificuldade em estabelecer relações, sem atitude combativa e com baixo autocontrole.',
    baixo:
      'Disposição geral um pouco abaixo da média; alguma facilidade relacional, mas combatividade e autocontrole ainda aquém.',
    medio:
      'Boa capacidade relacional, combatividade adequada para persuadir e autocontrole; perfil compatível com atividades comerciais.',
    acima_media:
      'Acima da média: facilidade para relacionar, boa combatividade e autocontrole consistente.',
    alto:
      'Muito acima da média: grande capacidade relacional, alta combatividade e ótimo autocontrole.'
  },

  R: {
    muito_baixo:
      'Baixa empatia; escuta e compreensão precárias; dificuldade de adaptação; baixo autocontrole e baixa tolerância à frustração.',
    baixo:
      'Empatia e adaptação presentes porém abaixo da média; escuta/compreensão/autocontrole/tolerância ainda frágeis.',
    medio:
      'Boa receptividade: escuta, compreende e adapta-se; com autocontrole e tolerância à frustração.',
    acima_media:
      'Receptividade acima da média: escuta qualificada, compreensão acurada, adaptação fácil e bom autocontrole.',
    alto:
      'Excelente empatia, escuta e compreensão; adapta-se com facilidade e mantém alto autocontrole e resiliência.'
  },

  A: {
    muito_baixo:
      'Baixa atividade/dinamismo; evita conflitos; pouca ascendência e segurança; não se impõe comercialmente.',
    baixo:
      'Alguma atividade e disposição para conflito, porém abaixo do esperado; ascendência ainda limitada.',
    medio:
      'Ativo e dinâmico; suporta e provoca conflitos orientado a resultados; possui ascendência e segurança.',
    acima_media:
      'Acima da média em atividade/dinamismo e capacidade de lidar com conflitos; exerce ascendência típica de liderança.',
    alto:
      'Extremamente ativo e orientado a vencer; provoca e suporta conflitos; domina/persuasivo e tolerante ao risco.'
  },

  I: {
    muito_baixo:
      'Baixa empatia e objetividade nas relações; pouca intuição e integração de informações.',
    baixo:
      'Alguma empatia/objetividade, mas abaixo da média; intuição e integração ainda inconsistentes.',
    medio:
      'Empático e objetivo; intuitivo e capaz de integrar pessoas/situações ao contexto.',
    acima_media:
      'Empatia, objetividade e intuição acima da média; integra com facilidade acontecimentos e pessoas.',
    alto:
      'Altíssima empatia/objetividade e percepção social; integra cenários com precisão.'
  },

  II: {
    muito_baixo:
      'Dificuldade para adaptar-se a situações/pessoas novas; inflexibilidade cognitiva e relacional.',
    baixo:
      'Consegue adaptar-se, mas abaixo da média; flexibilidade limitada.',
    medio:
      'Adapta-se com boa velocidade e flexibilidade a pessoas e contextos distintos.',
    acima_media:
      'Adaptação rápida e flexível em ambientes variados; acima da média.',
    alto:
      'Altamente adaptável; ajusta-se com facilidade e mantém flexibilidade ampla.'
  },

  III: {
    muito_baixo:
      'Baixo autocontrole; má administração do potencial; organização e perseverança frágeis.',
    baixo:
      'Algum autocontrole, mas ainda com falhas de organização/perseverança.',
    medio:
      'Autocontrole adequado; administra bem o potencial; organizado e perseverante.',
    acima_media:
      'Ótimo autocontrole; organização e perseverança acima da média.',
    alto:
      'Autocontrole elevado; administra o potencial com eficiência; altamente organizado e perseverante.'
  },

  IV: {
    muito_baixo:
      'Baixa tolerância à frustração; tende a personalizar e lidar mal com fracassos.',
    baixo:
      'Alguma tolerância, porém instável; pode personalizar situações e sofrer com contratempos.',
    medio:
      'Tolera frustrações de forma adequada; compreende fracassos sem personalizar.',
    acima_media:
      'Boa tolerância; compreende e lida bem com adversidades.',
    alto:
      'Alta tolerância; aprende com fracassos e evita personalização de eventos.'
  },

  V: {
    muito_baixo:
      'Dificuldade para lidar com desacordos; agressividade comercial praticamente ausente.',
    baixo:
      'Evita conflitos e nem sempre suporta desacordos; combatividade abaixo da média.',
    medio:
      'Suporta desacordos e participa de conflitos quando necessário; combatividade adequada.',
    acima_media:
      'Acima da média em combatividade; sustenta posições em situações conflituosas.',
    alto:
      'Provoca/conduz conflitos para persuadir; suporta desacordos; persistente e assertivo.'
  },

  VI: {
    muito_baixo:
      'Baixa vontade de domínio; pouca persuasão/influência.',
    baixo:
      'Potencial para dominar/persuadir existe, mas raramente é exercido.',
    medio:
      'Vontade de domínio e persuasão compatíveis com papéis de influência.',
    acima_media:
      'Acima da média em domínio/persuasão; exerce ascendência.',
    alto:
      'Elevada capacidade de domínio/persuasão; influência consistente e postura de liderança.'
  },

  VII: {
    muito_baixo:
      'Inseguro; evita novidades/inesperados; evita riscos.',
    baixo:
      'Menos seguro; prefere previsibilidade, mas enfrenta riscos quando necessário.',
    medio:
      'Seguro; aprecia novidades e enfrenta riscos calculados.',
    acima_media:
      'Muito seguro; busca desafios e tolera incerteza.',
    alto:
      'Extremamente seguro; confortável com riscos e mudanças.'
  },

  VIII: {
    muito_baixo:
      'Baixa atividade; tendência à passividade.',
    baixo:
      'Atividade suficiente para o básico, porém abaixo da média para contexto comercial.',
    medio:
      'Ativo; rejeita passividade; engaja-se com energia.',
    acima_media:
      'Acima da média em energia e participação.',
    alto:
      'Muito ativo; gosta de esportes/ação; alta energia física e motivacional.'
  },

  IX: {
    muito_baixo:
      'Introvertido; dificuldade para criar contatos; prefere isolamento.',
    baixo:
      'Pouco sociável em geral; pode ser extrovertido em contextos específicos.',
    medio:
      'Sociável; cria contatos e convive bem; sensível às relações.',
    acima_media:
      'Muito sociável; cria e mantém ampla rede de contatos.',
    alto:
      'Altíssima sociabilidade; busca/cria contatos; forte orientação a relacionamento.'
  }
};

export default interpretacaoICV;
